module.exports = __webpack_public_path__ + "img/chinook.8f6ee331.jpg";